import { render, staticRenderFns } from "./PageHistoricalFigures.vue?vue&type=template&id=57ccc110&"
import script from "./PageHistoricalFigures.vue?vue&type=script&lang=js&"
export * from "./PageHistoricalFigures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ccc110')) {
      api.createRecord('57ccc110', component.options)
    } else {
      api.reload('57ccc110', component.options)
    }
    module.hot.accept("./PageHistoricalFigures.vue?vue&type=template&id=57ccc110&", function () {
      api.rerender('57ccc110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/historicalFigures/PageHistoricalFigures.vue"
export default component.exports